export default __webpack_public_path__ + "static/media/discord.0c4e0a3c.svg";